import ApplicationSerializer from './application';

export default ApplicationSerializer.extend({
  get include() {
    return ['agreeableNdas', 'agreeable-ndas.agreement', 'parent-invite-context', 'child-invite-locations'];
  },
});
